import myExam from "../../layout/myExam"
// 注意路由格式前缀一定要加/myExam
export default {
    path: "/myExam/index",
    component: myExam,
    redirect: "/myExam/courseAll",
    alwaysShow: true,
    name: "myExam",
    children: [
        {
            path: "/myExam/courseAll",
            name: "courseAllIndex",
            meta: {
                parent:{
					path:'/myExam/courseAll',
					title:'全部课程',
					mosttitle:'全部课程' 
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'全部课程',index:0
            },
            component: () => import("@/weMyExamViews/courseAll/index")  
        },
        {
            path: "/myExam/testingCenter",
            name: "testingCenterIndex",
            meta: {
                parent:{
					path:'/myExam/testingCenter',
					title:'考试中心',
					mosttitle:'考试中心'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'考试中心',index:1
            },
            component: () => import("@/weMyExamViews/myExam/index")  
        }, 
        {
            path: "/myExam/examRecords",
            name: "examRecordsIndex",
            meta: {
                parent:{
					path:'/myExam/examRecords',
					title:'考试记录',
					mosttitle:'考试记录'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'考试记录',index:2
            },
            component: () => import("@/weMyExamViews/myExam/examRecords")  
        },
        {
            path: "/myExam/mobileMyExam",
            name: "mobileMyExamIndex",
            meta: {
                parent:{
					path:'/myExam/testingCenter',
					title:'考试中心',
					mosttitle:'考试中心'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'考试中心',index:1
            },
            component: () => import("@/weMyExamViews/mobileExam/mobileMyExam")  
        },
        {
            path: "/myExam/examLogin",
            name: "examLogin",
            meta: {
                parent:{
					path:'/myExam/testingCenter',
					title:'考试中心',
					mosttitle:'考试中心'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'考生登录',index:2
            },
            component: () => import("@/weMyExamViews/examLogin/index")  
        },
        {
            path: "/myExam/doExam",
            name: "doExam",
            meta: {
                parent:{
					path:'/myExam/testingCenter',
					title:'考试中心',
					mosttitle:'考试中'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'考试中',index:3
            },
            component: () => import("@/weMyExamViews/doExam/index")  
        },
        {
            path: "/myExam/mobildDoExam",
            name: "mobildDoExam",
            meta: {
                parent:{
					path:'/myExam/testingCenter',
					title:'考试中心',
					mosttitle:'考试中'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'考试中',index:3
            },
            component: () => import("@/weMyExamViews/mobileExam/mobildDoExam")  
        },
        {
            path: "/myExam/transcriptExam",
            name: "transcriptExam",
            meta: {
                parent:{
					path:'/myExam/testingCenter',
					title:'考试中心',
					mosttitle:'成绩单'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'成绩单',index:2
            },
            component: () => import("@/weMyExamViews/transcriptExam/index")  
        },
        {
            path: "/myExam/transcriptExam1",
            name: "transcriptExam1",
            meta: {
                parent:{
					path:'/myExam/testingCenter',
					title:'考试中心',
					mosttitle:'仿真成绩单'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'仿真成绩单',index:3
            },
            component: () => import("@/weMyExamViews/transcriptExam/rasoIndex")  
        },
        {
            path: "/myExam/practiceExam",
            name: "practiceExam",
            meta: {
                parent:{
					path:'/myExam/testingCenter',
					title:'考试中心',
					mosttitle:'练习考试'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'练习',index:3
            },
            component: () => import("@/weMyExamViews/practiceExam/index")  
        },
        {
            path: "/myExam/mobilePracticeExam",
            name: "mobilePracticeExam",
            meta: {
                parent:{
					path:'/myExam/testingCenter',
					title:'考试中心',
					mosttitle:'练习考试'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'练习',index:3
            },
            component: () => import("@/weMyExamViews/mobileExam/mobilePracticeExam")  
        },
        {
            path: "/myExam/wrongBook",
            name: "wrongBookIndex",
            meta: {
                parent:{
					path:'/myExam/wrongBook',
					title:'错题本',
					mosttitle:'错题本'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'错题本',index:3
            },
            component: () => import("@/weMyExamViews/wrongBook/index")  
        }, 
        {
            path: "/myExam/wrongDetail",
            name: "wrongDetailIndex",
            meta: {
                parent:{
					path:'/myExam/wrongDetail',
					title:'错题本',
					mosttitle:'错题本'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'错题详情',index:3
            },
            component: () => import("@/weMyExamViews/wrongBook/wrongdetail")  
        },
        {
            path: "/myExam/courseUser",
            name: "courseUserIndex",
            meta: {
                parent:{
					path:'/myExam/courseUser',
					title:'我的课程',
					mosttitle:'我的课程'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'我的课程',index:4
            },
            component: () => import("@/weMyExamViews/courseUser/index")  
        },
        {
            path: "/myExam/learningRecord",
            name: "learningRecordIndex",
            meta: {
                parent:{
					path:'/myExam/learningRecord',
					title:'学习记录',
					mosttitle:'学习记录'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'学习记录',index:5
            },
            component: () => import("@/weMyExamViews/learningRecord/index")  
        },
        {
            path: "/myExam/certList",
            name: "certListIndex",
            meta: {
                parent:{
					path:'/myExam/certList',
					title:'我的证书',
					mosttitle:'我的证书'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'我的证书',index:6
            },
            component: () => import("@/weMyExamViews/certList/index")  
        },
    ]
}